import React, { useEffect, useState } from 'react';
import { NextSeo } from 'next-seo';
import absoluteUrl from 'next-absolute-url';

import openApi from 'api/openApi';
import { isMobile } from 'react-device-detect';

import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';

import Layout from 'components/Layout';
import MapaAnuncio from 'components/MapaAnuncio';
import GPTComponent from '../../components/gpt/gpt';
import Aberto from '../../components/LeadBox/Aberto';
import RedeSocial from '../../components/RedeSocial';
import Fechado from '../../components/LeadBox/Fechado';
import FolderImovel from '../../components/FolderImovel';
import AnuncioDetalhado from 'components/AnuncioDetalhado';
import AnunciosSimilares from 'components/Mapeamento/Similares';
import MobileBottomBarAnuncio from '../../components/MobileBottomBarAnuncio';
import ReportarAnuncio from '../../components/ReportarAnuncio';
import { LeadBoxFechadoWrapperMobile } from '../../components/LeadBox/Fechado/fechado-styled';

import { decode } from 'html-entities';

const Anuncio = ({ anuncio, similares, motivosDenuncia, canonicalUrl }) => {
    const [isShortWidth, setIsShortWidth] = useState(false);

    useEffect(() => {
        setIsShortWidth(window.innerWidth < 768);
    }, [isShortWidth]);

    return (
        <>
            <Layout>
                <NextSeo
                    title={anuncio.titulo}
                    description={
                        anuncio.descricao
                            ? anuncio.descricao
                                  .replace(/(<([^>]+)>)/gi, '')
                                  .substring(0, 153)
                            : ''
                    }
                    canonical={canonicalUrl}
                    openGraph={{
                        title: anuncio.titulo,
                        description: anuncio.descricao
                            ? anuncio.descricao
                                  .replace(/(<([^>]+)>)/gi, '')
                                  .substring(0, 153)
                            : '',
                        url: canonicalUrl,
                    }}
                    additionalMetaTags={[
                        {
                            property: 'url',
                            content: canonicalUrl,
                        },
                    ]}
                />
                <AnuncioDetalhado anuncio={anuncio} />

                {anuncio.tipoLocalizacao != 'NAO_MOSTRAR' && (
                    <MapaAnuncio anuncio={anuncio} />
                )}

                <Container>
                    <FolderImovel idAnuncio={anuncio.id} />

                    <LeadBoxFechadoWrapperMobile>
                        <Fechado
                            anunciante={anuncio.anunciante}
                            idAnuncio={anuncio.id}
                            tituloAnuncio={anuncio.titulo}
                        />
                    </LeadBoxFechadoWrapperMobile>

                    <Aberto
                        anunciante={anuncio.anunciante}
                        idAnuncio={anuncio.id}
                        tituloAnuncio={anuncio.titulo}
                    />

                    <RedeSocial titulo={anuncio.titulo} />

                    <div>
                        {isShortWidth && <GPTComponent gpt="arroba" />}
                        {!isShortWidth && <GPTComponent gpt="megabox" />}
                    </div>

                    <div>
                        <Typography variant="h2">
                            <Box
                                fontSize="18px"
                                fontWeight="bold"
                                marginTop="41px"
                                marginBottom="16px"
                            >
                                Anúncios similares
                            </Box>
                        </Typography>
                        <AnunciosSimilares similares={similares} />
                    </div>

                    <ReportarAnuncio
                        listaMotivos={motivosDenuncia}
                        idAnuncio={anuncio.id}
                    />
                </Container>
            </Layout>

            {isMobile && (
                <MobileBottomBarAnuncio
                    anunciante={anuncio.anunciante}
                    idAnuncio={anuncio.id}
                    tituloAnuncio={anuncio.titulo}
                />
            )}
        </>
    );
};

export async function getServerSideProps(ctx) {
    const {
        consultarAnuncio,
        consultarMotivosDenuncia,
        consultarAnunciosSimilares,
    } = openApi();

    const { origin } = absoluteUrl(ctx.req);

    let props = {
        canonicalUrl: `${origin}${ctx.resolvedUrl}`,
        referrer: ctx?.req?.headers?.referer || null,
        anuncio: null,
        similares: [],
        motivosDenuncia: [],
    };

    const id = ctx.params.id.split('-').reverse()[0];
    await consultarAnuncio(id).then((resp) => (props.anuncio = {
        ...resp,
        descricao: decode(resp.descricao)
    }));
    await consultarMotivosDenuncia(id).then(
        (resp) => (props.motivosDenuncia = resp)
    );
    await consultarAnunciosSimilares(id).then(
        (resp) => (props.similares = resp)
    );

    if (!props.anuncio) {
        return {
            notFound: true,
        };
    }

    return {
        props: props
    };
}

export default Anuncio;
